import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from './analytics';

/**
 * Component that tracks page views on every route change.
 * Drop this inside the RouterProvider's context.
 *
 * Usage (inside a layout component that's within the Router):
 *   <RouteChangeListener />
 */
export function RouteChangeListener() {
  const location = useLocation();

  useEffect(() => {
    analytics.pageView(location.pathname + location.search, document.title);
  }, [location.pathname, location.search]);

  return null;
}